var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center guide-btn-wrapper",class:{'active': _vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"btn-icon mr-2 text-silver",class:_vm.icon,style:({fontSize: _vm.iconSize})}),_c('span',{staticClass:"btn-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }